export const DASHBOARD_COLOR_POSITION_SUFFIX = "-colorPosition";
export const DASHBOARD_OPPORTUNITY_ID_SUFFIX = "-opportunityId";